export default "__VITE_ASSET__BTA85Clg__"